import {
  Checkbox,
  FilledInput,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import styled from "styled-components";
import { StyledCheckbox } from "../../../../../components/Checkboxes/checkboxes";
import { Input } from "../../../../../components/Input/input";
import { theme } from "../../../../../helpers/theme";
import FormFieldInfo from "../form-field-info/form-field-info";

interface CheckboxesSectionProps {
  currentValues: string[];
  checkboxesOptions: string[];
  popoverLabel: string;
  popoverContent: string;
  formik?: any;
  helperFieldDisplay?: boolean;
  helperFieldName?: string;
  setCurrentValues: (element: string[]) => void;
}

const CheckboxesSection = ({
  currentValues,
  checkboxesOptions,
  popoverLabel,
  popoverContent,
  formik,
  helperFieldDisplay,
  helperFieldName,
  setCurrentValues,
}: CheckboxesSectionProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setCurrentValues([...currentValues, e.target.name]);
    } else {
      const filteredOptions = [...currentValues].filter(
        (option) => option !== e.target.name
      );
      setCurrentValues(filteredOptions);
    }
  };

  return (
    <AdditionalServicesSectionContainer>
      <FormFieldInfo
        popoverLabel={popoverLabel}
        popoverContent={popoverContent}
      />
      <LocationWrapper>
        {checkboxesOptions.map((item, index) => (
          <ItemWrapper key={index}>
            <FormControlLabel
              key={item}
              value={item}
              control={
                <StyledCheckbox
                  onChange={(e: any) => handleChange(e)}
                  name={item}
                  checked={currentValues.includes(item)}

                  // sx={{ backgroundColor: "white" }}
                />
              }
              label={item}
            />
          </ItemWrapper>
        ))}
      </LocationWrapper>
      {currentValues.length > 0 && (
        <>
          <AdditionalServicesQuantitySectionContainer>
            <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
              <StyledSummaryInput
                id="additionalServicesQuantity"
                name="additionalServicesQuantity"
                value={formik.values.additionalServicesQuantity}
                onChange={formik.handleChange}
                error={
                  formik.touched.additionalServicesQuantity &&
                  Boolean(formik.errors.additionalServicesQuantity)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">szt.</InputAdornment>
                }
                aria-describedby="filled-additionalServicesQuantity-helper-text"
                inputProps={{
                  "aria-label": "additionalServicesQuantity",
                }}
              />
              <FormHelperText id="filled-additionalServicesQuantity-helper-text">
                Ilość
              </FormHelperText>
            </FormControl>
          </AdditionalServicesQuantitySectionContainer>
          {formik.values.additionalServicesQuantity <= 0 && (
            <CustomInformationsHelperText>
              Wprowadź wartość większą od 0
            </CustomInformationsHelperText>
          )}
        </>
      )}

      {helperFieldDisplay && (
        <CustomInformationsWrapper>
          <Input
            label="Zacznij pisać..."
            id="additionalServicesDescription"
            name="additionalServicesDescription"
            value={formik.values.additionalServicesDescription}
            onChange={formik.handleChange}
            error={
              formik.touched.additionalServicesDescription &&
              Boolean(formik.errors.additionalServicesDescription)
            }
            helperText={
              formik.touched.additionalServicesDescription &&
              formik.errors.additionalServicesDescription
            }
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ width: "100%" }}
          />
          <CustomInformationsHelperText>
            {formik.values.additionalServicesDescription
              ? null
              : `Pole wymagane*`}
          </CustomInformationsHelperText>
        </CustomInformationsWrapper>
      )}
    </AdditionalServicesSectionContainer>
  );
};

export default CheckboxesSection;

const AdditionalServicesSectionContainer = styled.div`
  width: 100%;
`;
const ItemWrapper = styled.div`
  width: 160px;
`;
export const CustomInformationsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;
export const CustomInformationsHelperText = styled.span`
  font-family: ${theme.fonts.interMedium};
  color: #ff0040;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
  margin-left: 8px;
`;
const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 2px;
`;
const AdditionalServicesQuantitySectionContainer = styled.div`
  width: 220px;
  flex-wrap: wrap;
  margin-top: 10px;

  padding: 6px 0 0 6px;
  display: flex;
  justify-content: flex-start;
  background-color: white;

  border-radius: 10px;
`;
const StyledSummaryInput = styled(FilledInput)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
